
import './lib/i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './rd.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);

console.log("Starting School Sticker Creator Application...");

// Register Service Worker for PWA support — production only. Its cache-first
// strategy is exactly wrong for dev: it would keep serving an old bundle over
// Vite's live-reloaded source. In dev, actively unregister any SW left over
// from a previous production build served on this origin, so it can't shadow
// current edits with a stale cached bundle.
if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').then(registration => {
        console.log('SW registered: ', registration);
      }).catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
    });
  } else {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
}

// Render the main application, wrapped in StrictMode for development checks
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
